function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.09668 0.753412C1.22793 0.753412 1.36055 0.797162 1.47129 0.884662L7.26543 5.5454C7.40625 5.65888 7.48828 5.82978 7.48828 6.01162C7.48828 6.19208 7.40625 6.36435 7.26543 6.47646L1.4959 11.1126C1.23887 11.319 0.862891 11.278 0.656446 11.021C0.45 10.764 0.491015 10.388 0.748047 10.1815L5.93789 6.01162L0.72207 1.81572C0.465039 1.60927 0.424024 1.23329 0.630469 0.976263C0.749414 0.829974 0.921679 0.753412 1.09668 0.753412Z",
  fill: "currentColor"
});

var SvgIcRight = function SvgIcRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_right.f7df6c39.svg";
export { ForwardRef as ReactComponent };